type Step = "treatment" | "plan" | "checkout";

const STEPS: { key: Step; index: number; label: string }[] = [
  { key: "treatment", index: 1, label: "Treatment" },
  { key: "plan", index: 2, label: "Plan" },
  { key: "checkout", index: 3, label: "Checkout" },
];

const CarePlusStepper = ({ current, t, compact, variant }: { current: Step; t: (key: string, fallback: string) => string; compact?: boolean; variant?: "white" }) => {
  const currentIndex = STEPS.findIndex((s) => s.key === current);
  const dotSize = compact ? "size-[20px]" : "size-[24px]";
  const dotTextSize = compact ? "text-[11px]" : "text-[12px]";
  const labelTextSize = compact ? "text-[11px]" : "text-[13px]";
  const isWhiteVariant = variant === "white";

  return (
    // Dot + label blocks are fixed-width siblings and the connector lines are the only flexible
    // children, so both lines get the same length whatever the labels' widths are.
    <div className="flex w-full min-w-0 items-center gap-[7px]">
      {STEPS.map((step, i) => (
        <div key={step.key} className="contents">
          <div className="flex shrink-0 items-center gap-[6px]">
            <div
              className={`flex ${dotSize} shrink-0 items-center justify-center rounded-[12px] ${dotTextSize} font-semibold ${
                isWhiteVariant ? "bg-white text-[#f59603]" : i <= currentIndex ? "bg-[#f59603] text-white" : "border-[1.5px] border-[#c9ced4] bg-white text-[#99a3b2]"
              } ${i > currentIndex ? "opacity-40" : ""}`}
            >
              {i < currentIndex ? "✓" : step.index}
            </div>
            <span
              className={`whitespace-nowrap ${labelTextSize} ${
                isWhiteVariant ? (i <= currentIndex ? "font-semibold text-white" : "font-medium text-white opacity-50") : (i <= currentIndex ? "font-semibold text-[#f59603]" : "font-medium text-[#99a3b2]")
              }`}
            >
              {t(`step_${step.key}`, step.label)}
            </span>
          </div>
          {i < STEPS.length - 1 && <div className={`h-px min-w-[10px] flex-1 rounded-[2px] ${i < currentIndex ? (isWhiteVariant ? "bg-white" : "bg-[#f59603]") : "bg-[#e7e4db]"}`} />}
        </div>
      ))}
    </div>
  );
};

export default CarePlusStepper;
